/**
 * @generated SignedSource<<6125a63e56a21df663c77386bc93d78b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type UserRoleEnum = "admin" | "customer_success_rep" | "recruiter" | "sales" | "screening";
import { FragmentRefs } from "relay-runtime";
export type user_isRecruiterOrAdmin$data = {
  readonly realUser: {
    readonly roles: ReadonlyArray<UserRoleEnum> | null | undefined;
  } | null | undefined;
  readonly roles: ReadonlyArray<UserRoleEnum> | null | undefined;
  readonly " $fragmentType": "user_isRecruiterOrAdmin";
};
export type user_isRecruiterOrAdmin$key = {
  readonly " $data"?: user_isRecruiterOrAdmin$data;
  readonly " $fragmentSpreads": FragmentRefs<"user_isRecruiterOrAdmin">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "user_isRecruiterOrAdmin"
};

(node as any).hash = "0122c68f894444fc0fa42148906d9381";

export default node;
